import { Box, Flex, Image, Text, VStack, HStack, Link, Heading } from "@chakra-ui/react";

export default function PreFooter() {
    return (
        <Box bg="gray.800" py={{ base: 10, md: 16 }} px={{ base: 6, md: 12 }} color="white">
            <Flex maxW="1200px" mx="auto" justify="space-between" direction={{ base: "column", md: "row" }} gap={{ base: 8, md: 12 }}>
                <HStack spacing={4} justify={{ base: "center", md: "flex-start" }}>
                    <Image src={require("../images/logo.png")} alt="Swift Credit Logo" boxSize={{ base: "40px", md: "48px" }} style={{ mixBlendMode: "lighten" }} />
                    <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold">
                        Swift Credit
                    </Text>
                </HStack>

                <Flex
                    gap={{ base: 6, md: 20 }}
                    wrap={{ base: "nowrap", md: "wrap" }}
                    direction={{ base: "column", md: "row" }}
                    align={{ base: "center", md: "stretch" }}
                    justify={{ base: "center", md: "flex-end" }}
                    textAlign={{ base: "center", md: "left" }}
                >
                    <VStack align={{ base: "center", md: "flex-start" }} spacing={3}>
                        <Link href="/#how-it-works" _hover={{ textDecoration: "none" }}>
                            <Heading size="sm">How it works</Heading>
                        </Link>
                    </VStack>

                    <VStack align={{ base: "center", md: "flex-start" }} spacing={3}>
                        <Heading size="sm">Instan Loans</Heading>
                        <Link href="/short-term-loan">Short term loan</Link>
                        {/*<Link href="/payday-loan">Payday loan</Link>*/}
                        <Link href="/eligibility">Who qualifies?</Link>
                        <Link href="/#loan-calculator">Loan calculator</Link>
                    </VStack>

                    <VStack align={{ base: "center", md: "flex-start" }} spacing={3}>
                        <Heading size="sm">Company</Heading>
                        <Link href="/about">About Swift Credit</Link>
                        <Link href="/promotions">Promotions</Link>
                        <Link href="/community">Refer and Earn</Link>
                        <Link href="/influencer">Become our Influencer</Link>
                    </VStack>

                    <VStack align={{ base: "center", md: "flex-start" }} spacing={3}>
                        <Heading size="sm">Resources</Heading>
                        <Link href="/blog">Blog</Link>
                        <Link href="/#faq-section">FAQs</Link>
                        <Link href="/help">Help</Link>
                    </VStack>

                    <VStack align={{ base: "center", md: "flex-start" }} spacing={3}>
                        <Heading size="sm">Legal</Heading>
                        <Link href="/terms-of-service">Terms of Service</Link>
                        <Link href="/privacy-policy">Privacy Policy</Link>
                    </VStack>
                </Flex>
            </Flex>
        </Box>
    );
}